// -----------------------------------------------------------------------------
// Scripts for FAQ
// -----------------------------------------------------------------------------

$(function () {
  $('.faq__heading').on('click', function() {
    const faqItem = $(this).parent();
    const activeContent = $(this).next();

    activeContent.slideToggle(300);
    faqItem.toggleClass('faq__item--active');

    $('.faq__content').not(activeContent).slideUp(300);
    $('.faq__item').not(faqItem).removeClass('faq__item--active');
  });
});